import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IAdminState,
  IAdminUser,
  IAdminUserResponseData,
} from "../types/admin-users";
import { IApiResponse } from "../types/api-response";

const initialState: IAdminState = {
  admins: [],
  admin: null,
  limit: 20,
  offset: 0,
  total: 0,
  loading: false,
  loadingAdminId: null,
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    setAdmins: (
      state,
      action: PayloadAction<IApiResponse<IAdminUserResponseData>>,
    ) => {
      state.admins = action.payload.data.items;
      state.limit = action.payload.data.limit;
      state.offset = action.payload.data.offset;
      state.total = action.payload.data.total;
    },

    setAdmin: (state, action: PayloadAction<IAdminUser>) => {
      state.admin = action.payload;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setAdmins, setAdmin, setLoading } = adminSlice.actions;

export default adminSlice.reducer;
